import axios from "axios";
import { api } from "@/lib/api";

export type SubmissionChannel = "email_pu" | "hzz_platforma" | "osobno";
export const channelLabels: Record<SubmissionChannel, string> = { email_pu: "E-pošta PU", hzz_platforma: "HZZ platforma", osobno: "Osobno" };
export interface PoliceAuthority { id: string; name: string; email: string; postal_address?: string | null }
export interface ApplicationOptions { channel?: SubmissionChannel; authority_id?: string; attachment_document_ids?: Record<string, string[]>; manual_values?: Record<string, string | string[]> }
export interface PermitApplication {
  channel_locked?: boolean; authority_id?: string | null;
  template_id: string; template_name: string; template_version: number; channel: SubmissionChannel;
  fields: { label: string; value: string | null; source: string; section?: string | null; manual?: boolean; dictionary?: string | null; multiple?: boolean; input_type?: string; choices?: { code: string; label: string }[] }[];
  attachments: { name: string; required: boolean; document_type_code: string; dokument_ids: string[]; missing: boolean; hzz_code?: string | null; problem?: string | null; count?: number }[];
  email: { to: string | null; subject: string; body: string } | null;
  max_attachment_bytes: number;
}
export async function getPoliceAuthorities() { return (await api.get<PoliceAuthority[]>("/dozvole/pu")).data; }
export async function savePoliceAuthority(body: { name: string; email: string; postal_address?: string | null }, id?: string) {
  return (id ? await api.patch<PoliceAuthority>(`/dozvole/pu/${id}`, body) : await api.post<PoliceAuthority>("/dozvole/pu", body)).data;
}
export async function getPermitApplication(id: string, options: ApplicationOptions = {}) {
  if (options.manual_values && Object.keys(options.manual_values).length) return (await api.post<PermitApplication>(`/dozvole/postupci/${id}/zahtjev/preview`, options)).data;
  const { attachment_document_ids, ...params } = options;
  return (await api.get<PermitApplication>(`/dozvole/postupci/${id}/zahtjev`, { params: { ...params, ...(attachment_document_ids ? { attachment_document_ids: JSON.stringify(attachment_document_ids) } : {}) } })).data;
}
export async function downloadPermitApplication(id: string, kind: "pdf" | "prilozi", options: ApplicationOptions) {
  try {
    return (await api.post<Blob>(`/dozvole/postupci/${id}/zahtjev/${kind}`, options, { responseType: "blob" })).data;
  } catch (cause) {
    // Axios returns JSON errors as a Blob too when downloading a PDF.
    if (axios.isAxiosError(cause) && cause.response?.data instanceof Blob) {
      try { cause.response.data = JSON.parse(await cause.response.data.text()) as unknown; } catch { /* Keep the generic Croatian fallback. */ }
    }
    throw cause;
  }
}
export async function submitPermitApplication(id: string, body: { submitted_on: string; channel: SubmissionChannel; authority_id: string | null; evidence_dokument_id: string | null; note?: string }) {
  await api.post(`/dozvole/postupci/${id}/predaja`, body);
}
export async function getGeneratedPermitFile(id: string, documentId: string) {
  return (await api.get<Blob>(`/dozvole/postupci/${id}/zahtjev/dokumenti/${documentId}`, { responseType: "blob" })).data;
}
export async function resolveEvidenceFile(workerId: string, documentId: string) {
  const id = (await resolveDocumentFiles(workerId, documentId))[0];
  if (!id) throw new Error("Odabrani dokument nema datoteku. Odaberite drugi dokaz.");
  return id;
}
export async function resolveDocumentFiles(workerId: string, documentId: string) {
  const files = (await api.get<{ dokument_id: string }[]>(`/radnici/${workerId}/documents/${documentId}/files`)).data;
  return files.map(file => file.dokument_id);
}

export async function recordPermitSubmission(id: string) { await api.post(`/dozvole/postupci/${id}/predaja-s-dozvole`); }
